import dayjs, { Dayjs } from "utils/dayjs"

import { Guid, IApiLink } from "@/types"
import { ApiLinkEntity, ApiLinkRel } from "config/constants"
import { toDateWithoutTimezone } from "utils/utils"

export interface IGetInvoiceIntervalDto {
    id: Guid
    sequence: number
    start: string
    end: string
    links: IApiLink[]
}

export interface IUpdateInvoiceIntervalDto {
    sequence: number
}

export interface IUpdateInvoiceIntervalEndDate {
    end: Dayjs
}

export interface IUpdateInvoiceIntervalEndDateDto {
    end: string
}

export const INVOICE_INTERVAL_SEQUENCE_MIN = 1
export const INVOICE_INTERVAL_SEQUENCE_MAX = 999

export default class InvoiceInterval {
    id: Guid
    sequence: number
    start: Dayjs
    end: Dayjs
    linkAddInvoiceIntervalAfter?: IApiLink
    linkUpdateInvoiceInterval?: IApiLink
    linkUpdateInvoiceIntervalEndDate?: IApiLink
    linkDeleteInvoiceInterval?: IApiLink

    constructor(dto: IGetInvoiceIntervalDto) {
        this.id = dto.id
        this.sequence = dto.sequence
        this.start = dayjs.utc(dto.start, "YYYY-MM-DD")
        this.end = dayjs.utc(dto.end, "YYYY-MM-DD")
        this.linkAddInvoiceIntervalAfter = dto.links.find(link => link.entity === ApiLinkEntity.invoiceInterval && link.rel === ApiLinkRel.new)
        this.linkUpdateInvoiceInterval = dto.links.find(link => link.entity === ApiLinkEntity.invoiceInterval && link.rel === ApiLinkRel.update)
        this.linkUpdateInvoiceIntervalEndDate = dto.links.find(link => link.entity === ApiLinkEntity.invoiceIntervalEndDate && link.rel === ApiLinkRel.update)
        this.linkDeleteInvoiceInterval = dto.links.find(link => link.entity === ApiLinkEntity.invoiceInterval && link.rel === ApiLinkRel.delete)
    }

    static getUpdateEndDateDto(data: IUpdateInvoiceIntervalEndDate): IUpdateInvoiceIntervalEndDateDto {
        return {
            end: toDateWithoutTimezone(data.end)
        }
    }
}
